<h3 mat-dialog-title class="dialog-title">Cancellation-policy<button [mat-dialog-close]="true" color="primary" mat-icon-button><mat-icon>close</mat-icon></button></h3>
<div mat-dialog-content>
  <div class="wrapper">
    <div class="innerWrapper">
      <ul>
        <ng-container *ngFor="let item of policy.cancellation_policy">
          <div class="policy">
            <div class="first">
              <h2>{{item.free_text}}</h2>
            </div>
           <div class="second">
            <h2>{{item.penalty_amount}}</h2>
            <mat-icon>percent</mat-icon>
           </div>
            
          </div>
        </ng-container>
      </ul>
    </div>
  </div>
</div>

